// eslint-disable-next-line import/no-extraneous-dependencies
import { Plugin } from '@nuxt/types';
import { CustomerIOWrapper } from '~/services/customerio';

const customerIOPlugin: Plugin = (_, inject) => {
  inject('customerIO', CustomerIOWrapper);
};

export default customerIOPlugin;
